
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Emit } from 'vue-property-decorator';

@Component
  export default class CPMissingDocuments extends Vue {

    @Emit('add')
    public add(): void {
      this.$store.commit('toggleMissingDocumentModal', false);
      if (this.$route.path !== '/my-account') {
        this.$router.push('/my-account');
      }

    }

    public close() {
      this.$store.commit('toggleMissingDocumentModal', false);
    }

    public mounted() {
      // this.$store.dispatch('getAlerts');
    }
  }
